import { http } from '@/utils/http'

export const getQuestion = async function (params = {}) {
  let url = '?r=series-paper/enter'
  if (Number(params.courseType) === 1) url = '?r=training-camp-paper/enter'
  const { data } = await http(url, params, 'GET')
  return data
}

export const submitQuestion = async function (params = {}) {
  let url = '?r=series-paper/submit'
  if (Number(params.courseType) === 1) url = '?r=training-camp-paper/submit'
  const { data } = await http(url, params, 'POST')
  return data
}

export const findAnalysis = async function (params = {}) {
  const url = '?r=exam/exam/view'
  const { data } = await http(url, params, 'GET')
  return data
}

export const getScoreInfo = async function (params = {}) {
  let url = '?r=series-paper/share'
  if (Number(params.courseType) === 1) url = '?r=training-camp-paper/share'
  const { data } = await http(url, params, 'GET')
  return data
}



// WEBPACK FOOTER //
// ./src/server/questions.js